import { environment } from '@/_shared/configuration/env';

export const API_LOGIN_WITH_SSO_CALL = (idpAlias?: string) => {
  const baseUrl = `${environment.VITE_APP_HOST_API_BASE}/idp/configurations/product/${environment.VITE_APP_ID}${idpAlias ? `/${idpAlias}` : ''}`;
  return baseUrl;
};
